<template>
  <div class="relative mx-auto min-h-[150px] max-w-content-container">
    <div v-if="loading" class="left-0 top-1/2 w-full py-10">
      <TheLoader />
    </div>

    <div v-else>
      <div v-if="!reports.length" class="pt-16 text-center text-xl">
        There are currently no reports published, please check back later
      </div>

      <div
        v-else
        data-testid="bea-reports"
        class="grid grid-cols-1 items-center justify-center gap-4 xl:grid-cols-2"
      >
        <div v-for="(report, index) in reports" :key="index">
          <SharedMarketReportCard
            :report="report"
            :category="BATTERY_EMISSIONS_ANALYSER.category"
            :initial-fields="initialFields"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TheLoader from '~/components/TheLoader.vue'
import SharedMarketReportCard from '~/components/shared/market/ReportCard.vue'

import { BATTERY_EMISSIONS_ANALYSER } from '~/constants/services/constants'
import type { TRecord } from '~/src/types/common'
import type { TReportCard } from '~/src/types/reports'

withDefaults(
  defineProps<{
    initialFields?: TRecord[]
    reports: TReportCard[]
    loading: boolean
  }>(),
  {
    initialFields: () => [],
    reports: () => [],
    loading: true,
  },
)
</script>
